<template>
    <router-link to="/about-project" class="adunit-block">
        <div class="adunit-content">
            <span class="adunit__subtitle">Velkomin á vefinn okkar!</span>
            <span class="adunit__title">Leitarvél nýrra bíla frá öllum umboðum</span>
        </div>

        <div class="iphones-imgs">
            <img :src="iphonesImgUrl" alt="">
        </div>
    </router-link>
</template>

<script>
import host from "@/helpers/getBaseUrl"
export default {
    computed: {
        iphonesImgUrl() {
            return `${host()}/img/page-about-project/iphones.png`
        }
    }
}
</script>